import { Type } from 'class-transformer';
import { DimensionOptionResultDto } from '../../common/dimensions/dimension-option-result-dto';
import { ARCreditApplicationTransactionItemResultDto } from './ar-credit-application-transaction-item-result-dto';

export class ARCreditApplicationSourceTransactionResultDto {
    unappliedAmount: number;
    customerCode: string;
    @Type(() => DimensionOptionResultDto)
    dimensions: DimensionOptionResultDto[];
    id: number;
    documentType: string;
    documentNumber: string;
    amount: number;
    @Type(() => Date)
    documentDate: Date;
    @Type(() => Date)
    postDate: Date;
    subLedgerTitle: string;
    subLedgerId: number;
    @Type(() => ARCreditApplicationTransactionItemResultDto)
    lineItems: ARCreditApplicationTransactionItemResultDto[];
}
